import { createSlice } from '@reduxjs/toolkit';
import {
  groupGet,
  createGroup,
  modifyOwner,
  removeMember,
  addMember,
  getTags,
  getMyGroup,
  getGroupDetails,
} from 'reduxStore/actions/group';
import { postGet } from 'reduxStore/actions/posts';

const initialState = {
  userLoading: false,
  group: [],
  groupDetail: null,
  groupPosts: [],
  myGroup: null,
  error: null,
};

const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Pending cases
      .addCase(groupGet.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getTags.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(createGroup.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(addMember.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(removeMember.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(modifyOwner.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getMyGroup.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(postGet.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })

      // Fulfilled cases
      .addCase(groupGet.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.groups) {
          state.group = action.payload.data.groups;
          state.groupDetail = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to fetch group';
        }
      })
      .addCase(createGroup.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
          state.group = action.payload.data.rows;
        } else {
          state.error = action.payload?.message || 'Failed to create group';
        }
      })
      .addCase(addMember.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.groupDetail = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to add member';
        }
      })
      .addCase(removeMember.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.groupDetail = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to remove member';
        }
      })
      .addCase(modifyOwner.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
          state.group = action.payload.data.rows;
        } else {
          state.error = action.payload?.message || 'Failed to modify owner';
        }
      })
      .addCase(getTags.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.group = action.payload.data;
        } else {
          state.error = action.payload?.message || 'Failed to fetch tags';
        }
      })
      .addCase(getMyGroup.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.myGroup = action.payload.data;
        } else {
          state.error = action.payload?.message || 'failed to fetch my group';
        }
      })
      .addCase(postGet.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data?.rows) {
          state.groupPosts = action.payload.data.rows;
        } else {
          state.error =
            action.payload?.message || 'Failed to fetch group posts';
        }
      })

      // Rejected cases
      .addCase(groupGet.rejected, (state, action) => {
        console.error('Error fetching group:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(createGroup.rejected, (state, action) => {
        console.error('Error creating group:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(getTags.rejected, (state, action) => {
        console.error('Error fetching tags:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(modifyOwner.rejected, (state, action) => {
        console.error('Error modifying owner:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(removeMember.rejected, (state, action) => {
        console.error('Error removing member:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(addMember.rejected, (state, action) => {
        console.error('Error adding member:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(getMyGroup.rejected, (state, action) => {
        console.error('Error fetching my group:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(postGet.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.error.message || 'Failed to fetch group posts';
      })
      .addCase(getGroupDetails.rejected, (state, action) => {
        console.error('Error fetching group details:', action.error.message);
        state.userLoading = false;
        state.error = action.error.message;
      })
      .addCase(getGroupDetails.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success && action.payload?.data) {
          state.groupDetail = action.payload.data;
        } else {
          state.error =
            action.payload?.message || 'Failed to fetch group details';
        }
      })
      .addCase(getGroupDetails.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      });
  },
});

export default groupSlice.reducer;
